import { render, staticRenderFns } from "./CustomerPlanSubscription.vue?vue&type=template&id=5f2385b4"
import script from "./CustomerPlanSubscription.vue?vue&type=script&lang=js"
export * from "./CustomerPlanSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports